// Loads the Window.env global augmentation.
import type {} from './types/global';
// declaring this here in AppConfig is the only way to get the tests to pass
// while using window.env. If not it will say it doesnt exist, and the tests fails
export type B2CConfig = {
  appRegistration: {
    clientId: string;
  };
  policies: {
    names: {
      forgotPassword: string;
      localSignUp: string;
    };
    authorities: {
      forgotPassword: {
        authority: string;
      };
      localSignUp: {
        authority: string;
      };
    };
    authorityDomain: string;
  };
  scopes: string;
};

type AppConfig = {
  MapBoxAPIKey: string;
  ApiBaseUrl: string;
  ApiSubToken: string;
  ApiServerToken: string;
  ApiServerTokenIngress: string;
  CompanyId: string;
  AuthTestMode: boolean;
  B2C: B2CConfig;
};

function getAppConfig(): AppConfig {
  return {
    MapBoxAPIKey: window?.env?.MAP_BOX_API_KEY || '',
    ApiBaseUrl: window?.env?.API_SERVER_URL || '',
    ApiSubToken: window?.env?.API_SERVER_TOKEN || '',
    ApiServerToken: window?.env?.API_SERVER_TOKEN || '',
    ApiServerTokenIngress: window?.env?.API_SERVER_TOKEN_INGRESS || '',
    CompanyId: window?.env?.COMPANY_ID || '',
    AuthTestMode: window?.env?.AUTH_TEST_MODE === 'true',
    B2C: {
      appRegistration: {
        clientId: window?.env?.B2C_CLIENT_ID || '',
      },
      policies: {
        names: {
          forgotPassword: window?.env?.FORGOT_PASSWORD || '',
          localSignUp: window?.env?.LOCAL_SIGN_UP || '',
        },
        authorities: {
          forgotPassword: {
            authority: window?.env?.FORGOT_PASSWORD_AUTHORITY || '',
          },
          localSignUp: {
            authority: window?.env?.LOCAL_SIGN_UP_AUTHORITY || '',
          },
        },
        authorityDomain: window?.env?.B2C_POLICIES_AUTHORITY_DOMAIN || '',
      },
      scopes: window?.env?.B2C_APP_SCOPES || '',
    },
  };
}

export const Config: AppConfig = getAppConfig();
